import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "11",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M5.93 5.931a.69.69 0 0 1-.211.5l-4.482 4.31a.688.688 0 1 1-.956-.993l3.966-3.814L.28 2.121a.69.69 0 1 1 .956-.994L5.719 5.44a.68.68 0 0 1 .212.492"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.069 10.932v-10H5.93v10z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }